'use client';

import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { SupportDemo } from './demos/SupportDemo';
import { DashboardDemo } from './demos/DashboardDemo';
import { FulfillmentDemo } from './demos/FulfillmentDemo';
import { ApiDemo } from './demos/ApiDemo';

interface ServiceDemoProps {
    type: string;
}

export const ServiceDemo = ({ type }: ServiceDemoProps) => {
    const getDemoComponent = () => {
        switch (type) {
            case 'support':
                return <SupportDemo />;
            case 'dashboard':
                return <DashboardDemo />;
            case 'fulfillment':
                return <FulfillmentDemo />;
            case 'api':
                return <ApiDemo />;
            default:
                return null;
        }
    };

    return <AnimatePresence mode="wait">{getDemoComponent()}</AnimatePresence>;
};
